

















import {Prop, Component, Watch, Model, Vue} from 'vue-property-decorator';
import ApiList from '@/api/list';
import {InternationalizedField} from '@/api/common';

interface NamedEntity {
    id: any;
    name: InternationalizedField<string>|string;
    getName(): string;
}

@Component
export default class MultiDropdownEntity extends Vue {
    @Model('update', {type: String}) public id?: any[];
    @Prop({type: String}) public placeholder!: string;
    @Prop() public list!: ApiList<NamedEntity>;
    @Prop({type: Boolean, default: false}) public disabled?: boolean;

    public options: object[] = null;
    public modeledId: string[] = [];

    public beforeMount() {
        this.loadOptions();
    }

    @Watch('list')
    public loadOptions() {
        if (this.list) {
            this.options = [];
            /*for (let option: NamedEntity of this.list.results) {*/
            for (const option of this.list.results) {
                this.options.push({ key: option.id, value: option.id, text: option.getName()});
            }
            this.modeledId = this.id;
        }
    }

    public getSelectedItemText() {
        if (this.list && this.id) {
            for (const item of this.list.results){
                if (item.id === this.id){
                    return item.getName();
                }
            }
        } else {
            return this.placeholder;
        }
    }

    @Watch('modeledId')
    public updateId() {
        this.$emit('update', this.modeledId);
    }

    @Watch('id')
    public updateModeledId() {
        this.modeledId = this.id;
    }
}

